import { render, staticRenderFns } from "./UserWorkoutsPage.vue?vue&type=template&id=66865344&scoped=true&"
import script from "./UserWorkoutsPage.vue?vue&type=script&lang=js&"
export * from "./UserWorkoutsPage.vue?vue&type=script&lang=js&"
import style0 from "./UserWorkoutsPage.vue?vue&type=style&index=0&id=66865344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66865344",
  null
  
)

export default component.exports